export const makeEnum = (value = '') => value.split(' ').join('').toUpperCase();
